import { instance } from "../helpers/http/apiclient";
import { venueHelper } from "../helpers/ui/venueHelper";
import { createTempBooking } from "../services/reservationService";

export const createPaymentIntent = async (
    storeId,
    amount,
    currency,
    customerID = "",
    paymentMethod = "",
    email = "",
    name = "",
    orderId = "",
    orderType = null,
) => {
    const payload = {
        currency: currency,
        Amount: Math.round(amount * 100),
        paymentID: paymentMethod,
        customerID: customerID,
        email,
        name,
        orderId,
        orderType,
        source: 'reservation',
    };
    try {
        const response = await instance.post(
            `/stripepayment/${storeId}/paymentintent`,
            JSON.stringify(payload)
        );
        const data = response.data;
        // response from cloud function should be success. otherwise return error message.
        if (response.status !== 200) throw new Error("Server respond with 400 error");
        if (!data.Success) {
            const error = data.Status && data.Status.Message ? data.Status.Message : "Internal Error Occurred";
            throw new Error(error);
        }
        return { status: true, error: "", data };
    } catch (ex) {
        const error = ex.message || "An error occurred. Please try again later.";
      return { status: false, error, data: null};
    }
};
  
export const confirmPaymentIntent = async (
    client_secret,
    paymentMethodId,
    stripe,
    card
) => {
    let result;
    try {
        if (paymentMethodId) {
            result = await stripe.confirmCardPayment(client_secret);
        } else {
            result = await stripe.confirmCardPayment(
                client_secret,
                { payment_method: { card: card } }
            );
        }

        if (result.error) {
            throw new Error(result.error.message || "Something went wrong! Please try again")
        }
        if (result.paymentIntent.status !== "succeeded") {
            throw new Error("Something went wrong! Please try again");
        }
        return { status: true, error: "" };
    } catch (ex) {
      const error = ex.message || "An error occurred. Please try again later.";
      return { status: false, error};
    }
};

export const deleteTempOrder = async (storeID, orderID) => {
    try {
      await instance.delete(
        `/bookings/${orderID}/delete/${storeID}`,
      );
    } catch (error) {
      console.error('deleteOrder -> error', error);
    }
}

export const handleCardPayment = async (
    totalAmount,
    storeId,
    bookingInfo,
    orderId,
    currency,
    stripe,
    cardElement,
    customerID = "",
    paymentMethod = ""
) => {
    try {
        if (totalAmount < 0) throw new Error("Invalid Amount");

        const bookingOrder = { ...bookingInfo };
        const email = bookingOrder.Email || "";
        const name = bookingOrder.BookingName || "";

        const createIntent = await createPaymentIntent(
            storeId,
            totalAmount,
            currency,
            customerID,
            paymentMethod,
            email,
            name,
            orderId,
        );
        if (createIntent.error) throw new Error(createIntent.error);

        const clientSecret = createIntent.data.ClientSecret;
        const paymentIntent = createIntent.data.PaymentIntent;
        bookingOrder.DepositReference = paymentIntent;

        const order = await createTempBooking(bookingOrder);
        if (order.error) throw new Error(order.error);

        const confirm = await confirmPaymentIntent(clientSecret, paymentMethod, stripe, cardElement);
        if (confirm.error) {
            await deleteTempOrder(storeId, orderId);
            throw new Error(confirm.error);
        }
        return {
            success: true,
            error: '',
        };
    } catch (error) {
        return {
            success: false,
            error: error.message || error,
        };
    }
}

export const handleBooking = async (
    reservationInfo,
    totalAmount,
    storeId,
    bookingInfo,
    orderId,
    currency,
    stripe,
    cardElement,
    customerID = "",
    paymentMethod = ""
) => {
    try {
        const isPayment = venueHelper.hasPayment(reservationInfo);
        const bookingOrder = { ...bookingInfo, HasPayment: isPayment };
        delete bookingOrder.Card;
        if (isPayment) {
            return await handleCardPayment(
                totalAmount,
                storeId,
                bookingOrder,
                orderId,
                currency,
                stripe,
                cardElement,
                customerID,
                paymentMethod,
            );
        }
        const order = await createTempBooking(bookingOrder);
        if (order.error) throw new Error(order.error);

        return {
            success: true,
            error: '',
        };
    } catch (error) {
        return {
            success: false,
            error: error.message || error,
        };
    }
}
